import appSettings from 'wanderu-config';
import Logger from 'wanderu-logger';
import AccountService from 'wanderu-service-account';
import { SnowplowService } from 'wanderu-service-analytics';

import { actions as userInfoActions } from '../../appstate/userInfo';
import { formatOrder } from '../utils';
import { actions } from './base';

const logger = Logger.getLogger('wanderu-ducks-account');

function reset(orderId) {
    return actions.reset(orderId);
}

function cancel(orderId) {
    return async (dispatch) => {
        dispatch(actions.startWork(orderId));

        let error;
        let meta = {};
        try {
            const canceledOrder = await AccountService.cancelTrip(orderId);
            const formattedCanceledOrder = formatOrder(canceledOrder);

            return dispatch(userInfoActions.updateUserOrder(formattedCanceledOrder));
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('cancelTrip', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });

            error = {
                code: ex.code,
                message: ex.message,
                name: ex.name,
            };
        } finally {
            dispatch(actions.endWork(orderId, meta, error));
        }
    };
}

export {
    cancel,
    reset,
};
